export const VEHICLE_TYPE_TRANSLATION_KEYS = {
  autobus: "AUTOBUS",
  kamion: "KAMION",
  kombi: "KOMBI",
  pick_up: "PICK_UP",
  automobil: "AUTOMOBIL",
  motor: "MOTOR",
};

export const getVehicleTypeLabel = (tip, t) => {
  if (!tip) return "";
  const key = VEHICLE_TYPE_TRANSLATION_KEYS[tip];
  if (!key) return tip;
  const translated = t?.(key);
  return translated || tip;
};
